import React from 'react';
import "../../ReusableComponent/UGNET/UGTopSection/UgTopSection.css";
import SeoHelmets from '../../SeoOptimazation/SeoHelmets';
import UgTopSection from '../../ReusableComponent/UGNET/UGTopSection/UgTopSection';
import userImage from "../../../Image/user.png";
import ugImage from "../../../Image/ugimg.jpg";
import UgrightSection from '../../ReusableComponent/UGNET/UGrightSection/UgrightSection';
import Content from '../../AllPageContent/AllPageContent';
import ButtonPage from '../../ButtonPage/ButtonPage';
import CurrentAffair from '../../CurrentAffair/CurrentAffair';

function UGSyllabus() {
  const Buttonname = "Multiplebutton";
  const componentName = "currentaffairs";
  // Banner Content For UGSYllabus Page
  const data = {
    academyName: 'SYLLABUS FOR UGC-NET EXAM',
    userImage: userImage,
    userName: 'Annirudh',
    Image: ugImage
  };

  // Content For UGSyllabus Page
  const paragraphs = [
    {
      text: "The first step of preparing for UGC NET is to be familiar with the UGC NET syllabus as this helps the aspirants to strategize their preparations in a well-defined manner. UGC NET 2021 exam will consist of 2 papers (Paper 1 & Paper 2), the UGC NET Paper 1 will be a common paper for all candidates while Paper 2 will be based on subject selected by the candidate. Let's have a look at the detailed UGC NET Syllabus for UGC NET 2021 Exam:",
      styles: [
        { word: '', style: "" },
      ],
    },
    {
      text: "UGC NET SYLLABUS FOR PAPER 1",
      styles: [
        { word: 'UGC NET SYLLABUS FOR PAPER 1', style: "background: green; text-align: center; display: block; color: white; font-weight: bold;" }
      ]
    },
    {
      text: "The UGC NET syllabus for Paper 1 consists of the subjects that will be helpful in analysing the candidate’s teaching and research ability, cognitive abilities, general awareness about teaching and learning processes in higher education system. The detailed syllabus and UGC NET Paper-1 Syllabus PDF file link has been provided below:",
      styles: [
        { word: 'analysing the candidate’s teaching and research ability, cognitive abilities, general awareness about teaching and learning processes in higher education system.', style: "font-weight: bold;" }
      ]
    },
    {
      text: "Unit-I: Teaching Aptitude Syllabus",
      styles: [
        { word: "Unit-I: Teaching Aptitude Syllabus", style: "font-weight: bold; text-decoration: underline;" }
      ]
    },
    {
      text: "1.  Teaching: Concept, Objectives, Levels of teaching (Memory, Understanding and Reflective), Characteristics and basic requirements.",
      styles: [
        { word: '1.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Teaching:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "2.  Learner’s characteristics: Characteristics of adolescent and adult learners (Academic, Social, Emotional and Cognitive), Individual differences.",
      styles: [
        { word: '2.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Learner’s characteristics:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "3.  Factors affecting teaching related to: Teacher, Learner, Support material, Instructional facilities, Learning environment and Institution.",
      styles: [
        { word: '3.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Factors affecting teaching related to:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "4.   Methods of teaching in Institutions of higher learning: Teacher centred vs. Learner centred methods; Off-line vs. On-line methods (Swayam, Swayamprabha, MOOCs etc.).",
      styles: [
        { word: '4.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Methods of teaching in Institutions of higher learning:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "5.      Teaching Support System: Traditional, Modern and ICT based.",
      styles: [
        { word: '5.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Teaching Support System:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "6.  Evaluation Systems: Elements and Types of evaluation, Evaluation in Choice Based Credit System in Higher education, Computer based testing, Innovations in evaluation systems.",
      styles: [
        { word: '6.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Evaluation Systems:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "Unit-II: Research Aptitude Syllabus",
      styles: [
        { word: "Unit-II: Research Aptitude Syllabus", style: "font-weight: bold; text-decoration: underline;" }
      ]
    },
    {
      text: "1.  Research: Meaning, Types, and Characteristics, Positivism and Postpositivistic approach to research.",
      styles: [
        { word: '1.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Research:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "2.  Methods of Research: Experimental, Descriptive, Historical, Qualitative and Quantitative methods, Steps of Research.",
      styles: [
        { word: '2.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Methods of Research:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "3.  Thesis and Article writing: Format and styles of referencing.",
      styles: [
        { word: '3.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Thesis and Article writing:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "4.   Application of ICT in research.",
      styles: [
        { word: '4.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "5.      Research ethics.",
      styles: [
        { word: '5.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "Unit-III Comprehension Syllabus",
      styles: [
        { word: "Unit-III Comprehension Syllabus", style: "font-weight: bold; text-decoration: underline;" }
      ]
    },
    {
      text: "1.  A passage of text be given. Questions be asked from the passage to be answered.",
      styles: [
        { word: '1.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "Unit-IV: Communication",
      styles: [
        { word: "Unit-IV: Communication", style: "font-weight: bold; text-decoration: underline;" }
      ]
    },
    {
      text: "1.  Communication: Meaning, types and characteristics of communication.",
      styles: [
        { word: '1.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Communication:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "2.  Effective communication: Verbal and Non-verbal, Inter-Cultural and group communications, Classroom communication.",
      styles: [
        { word: '2.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Effective communication:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "3.  Barriers to effective communication.",
      styles: [
        { word: '3.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "4.  Mass-Media and Society.",
      styles: [
        { word: '4.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "Unit-V: Mathematical Reasoning and Aptitude Syllabus",
      styles: [
        { word: "Unit-V: Mathematical Reasoning and Aptitude Syllabus", style: "font-weight: bold; text-decoration: underline;" }
      ]
    },
    {
      text: "1.  Types of reasoning.",
      styles: [
        { word: '1.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "2.  Number series, Letter series, Codes and Relationships.",
      styles: [
        { word: '2.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "3.  Mathematical Aptitude (Fraction, Time & Distance, Ratio, Proportion and Percentage, Profit and Loss, Interest and Discounting, Averages etc.).",
      styles: [
        { word: '3.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "Unit-VI: Logical Reasoning Syllabus",
      styles: [
        { word: "Unit-VI: Logical Reasoning Syllabus", style: "font-weight: bold; text-decoration: underline;" }
      ]
    },
    {
      text: "1.  Understanding the structure of arguments: argument forms, structure of categorical propositions, Mood and Figure, Formal and Informal fallacies, Uses of language, Connotations and denotations of terms, Classical square of opposition.",
      styles: [
        { word: '1.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Understanding the structure of arguments:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "2.  Evaluating and distinguishing deductive and inductive reasoning.",
      styles: [
        { word: '2.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "3.  Analogies.",
      styles: [
        { word: '3.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "4. Venn diagram: Simple and multiple use for establishing validity of arguments.",
      styles: [
        { word: '4.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Venn diagram:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "5. Indian Logic: Means of knowledge.",
      styles: [
        { word: '5.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Indian Logic:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "6. Pramanas: Pratyaksha (Perception), Anumana (Inference), Upamana (Comparison), Shabda (Verbal testimony), Arthapatti (Implication) and Anupalabddhi (Non-apprehension).",
      styles: [
        { word: '6.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Pramanas:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "7. Structure and kinds of Anumana (inference), Vyapti (invariable relation), Hetvabhasas (fallacies of inference).",
      styles: [
        { word: '7.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "Unit-VII: Data Interpretation Syllabus",
      styles: [
        { word: "Unit-VII: Data Interpretation Syllabus", style: "font-weight: bold; text-decoration: underline;" }
      ]
    },
    {
      text: "1.  Sources, acquisition and classification of Data.",
      styles: [
        { word: '1.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "2. Quantitative and Qualitative Data.",
      styles: [
        { word: '2.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "3. Graphical representation (Bar-chart, Histograms, Pie-chart, Table-chart and Line-chart) and mapping of Data.",
      styles: [
        { word: '3.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "4. Data Interpretation.",
      styles: [
        { word: '4.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "5. Data and Governance.",
      styles: [
        { word: '5.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "Unit-VIII: Information and Communication Technology (ICT) Syllabus",
      styles: [
        { word: "Unit-VIII: Information and Communication Technology (ICT) Syllabus", style: "font-weight: bold; text-decoration: underline;" }
      ]
    },
    {
      text: "1.  ICT: General abbreviations and terminology.",
      styles: [
        { word: '1.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "2. Basics of Internet, Intranet, E-mail, Audio and Video-conferencing.",
      styles: [
        { word: '2.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "3. Digital initiatives in higher education.",
      styles: [
        { word: '3.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "4. ICT and Governance.",
      styles: [
        { word: '4.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "Unit-IX: People, Development and Environment Syllabus",
      styles: [
        { word: "Unit-IX: People, Development and Environment Syllabus", style: "font-weight: bold; text-decoration: underline;" }
      ]
    },
    {
      text: "1.  Development and environment: Millennium development and Sustainable development goals.",
      styles: [
        { word: '1.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Development and environment:', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "2.  Human and environment interaction: Anthropogenic activities and their impacts on environment.",
      styles: [
        { word: '2.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Human and environment interaction:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "3.  Environmental issues: Local, Regional and Global; Air pollution, Water pollution, Soil pollution, Noise pollution, Waste (solid, liquid, biomedical, hazardous, electronic), Climate change and its Socio-Economic and Political dimensions.",
      styles: [
        { word: '3.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Environmental issues:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "4.  Impacts of pollutants on human health.",
      styles: [
        { word: '4.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "5.  Natural and energy resources: Solar, Wind, Soil, Hydro, Geothermal, Biomass, Nuclear and Forests.",
      styles: [
        { word: '5.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Natural and energy resources:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "6.  Natural hazards and disasters: Mitigation strategies.",
      styles: [
        { word: '6.', style: "font-weight: bold; color: #C00000;" },
        { word: 'Natural hazards and disasters:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "7. Environmental Protection Act (1986), National Action Plan on Climate Change, International agreements/efforts -Montreal Protocol, Rio Summit, Convention on Biodiversity, Kyoto Protocol, Paris Agreement, International Solar Alliance.",
      styles: [
        { word: '7.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "Unit-X: Higher Education System Syllabus",
      styles: [
        { word: "Unit-X: Higher Education System Syllabus", style: "font-weight: bold; text-decoration: underline;" }
      ]
    },
    {
      text: "1.  Institutions of higher learning and education in ancient India.",
      styles: [
        { word: '1.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "2.  Evolution of higher learning and research in Post-Independence India.",
      styles: [
        { word: '2.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "3.  Oriental, Conventional and Non-conventional learning programmes in India.",
      styles: [
        { word: '3.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "4.  Professional, Technical and Skill Based education.",
      styles: [
        { word: '4.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "5.  Value education and environmental education.",
      styles: [
        { word: '5.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "6.  Policies, Governance, and Administration.",
      styles: [
        { word: '6.', style: "font-weight: bold; color: #C00000;" },
      ]
    },
    {
      text: "NOTE: (i) Five questions each carrying 2 marks are to be set from each Module.(ii) Whenever graphical/pictorial question(s) are set for sighted candidates, a passage followed by equal number of questions and weightage be set for visually impaired candidates.",
      styles: [
        { word: 'NOTE:', style: "font-weight: bold;" },
      ]
    },
    {
      text: "UGC NET SYLLABUS FOR PAPER 2",
      styles: [
        { word: 'UGC NET SYLLABUS FOR PAPER 2', style: "background: green; text-align: center; display: block; color: white; font-weight: bold;" }
      ]
    },
    {
      text: "UGC NET Paper 2 will be based on subject-wise selected by the candidate. The Paper-II will also consist of only 100 objective type questions (MCQs) for 200 marks. A total of 101 subjects will be covered in the UGC NET Exam. Candidates will have to select one subject for the NET Exam preferably the subject of their post-graduation.",
      styles: [
        { word: '', style: "" }
      ]
    }
  ];

  return (
    <>
      <SeoHelmets
        title="UGC-NET Syllabus | Subject-wise Topics - Insight IAS"
        description="View the comprehensive syllabus for UGC-NET: Paper I & Paper II. Essential topics for research fellowship aspirants by Insight IAS."
        keywords="UGC-NET syllabus, paper 1 syllabus, research fellowship topics"
      />
      {/* Ug Syllabus Section Start */}
      <section className='ugall'>
        {/* Ug Top Section Start */}
        <UgTopSection
          academyName={data.academyName}
          userImage={data.userImage}
          userName={data.userName}
          Image={data.Image}
        />
        {/* Ug Top Section End */}
      </section>
      <div className='ug-section'>
        <div className='ug-row'>
          <div className='col-lg-8 col-md-12 col-sm-12 me-2'>
            {/* Content Component Start */}
            {/* list-style-type is "i" */}
            <Content paragraphs={paragraphs} listStyleType="i" />
            {/* Content Component End */}
            <ButtonPage Pagename={Buttonname} />
          </div>
          {/* Ug right Section Start */}
          <div className='col-lg-4 col-md-12 col-sm-12 card'>
            <div>
              <UgrightSection />
            </div>
            <div className="card-body">
              <CurrentAffair componentName={componentName} />
            </div>
          </div>
          {/* Ug right Section End */}
        </div>
      </div>
      {/* Ug Syllabus Section End */}
    </>
  )
}

export default UGSyllabus;